import { CheckCircle2 } from "lucide-react";
import { GeoMiniMapa } from "@/components/common/GeoMiniMapa";
import { BotonAbrirEnMapas } from "@/components/common/BotonAbrirEnMapas";

// Vista de SOLO LECTURA de una ubicación guardada: sello (fecha/hora/usuario) + coordenadas +
// mini-mapa Leaflet/OSM (GRATIS) + botón "Abrir en mapas" (deep link). Reutilizable en
// prospecto, solicitud, expediente (geo_visita) y Perfil 360.
export function UbicacionGuardada({ geo, label = "Ubicación confirmada", testid = "ubicacion-guardada" }) {
  if (!geo || geo.lat == null) return null;
  return (
    <div data-testid={testid} className="rounded-md border border-emerald-200 bg-emerald-50 p-3 text-xs text-emerald-800">
      <div className="flex items-center justify-between gap-2">
        <span className="flex items-center gap-1.5 font-semibold"><CheckCircle2 className="h-4 w-4" /> {label}</span>
        <BotonAbrirEnMapas lat={geo.lat} lng={geo.lng} className="h-7 px-2 text-[11px] border-emerald-300 text-emerald-800 hover:bg-emerald-100"
          testid={`${testid}-mapas`} />
      </div>
      {geo.sello && <p className="mt-1">{geo.sello.fecha} {geo.sello.hora} · {geo.sello.usuario}</p>}
      <p className="text-[11px] text-emerald-700">📍 {Number(geo.lat).toFixed(5)}, {Number(geo.lng).toFixed(5)}{geo.exactitud != null ? ` · ±${Math.round(geo.exactitud)} m` : ""}</p>
      <div className="mt-2"><GeoMiniMapa lat={Number(geo.lat)} lng={Number(geo.lng)} testid={`${testid}-mapa`} /></div>
    </div>
  );
}
